import React, { FC, useMemo } from "react";
import { SvgIconProps } from "@mui/material/SvgIcon";
import { useRhUserAtomValue } from "@RHCommerceDev/hooks/atoms";
import { useIsTradeOrContractPage } from "@RHCommerceDev/hooks/useIsTradeOrContractPage";

export const RHRAccountIcon: FC<SvgIconProps> = props => {
  const style = {
    ...props.style,
    cursor: " pointer"
  };

  const { userType } = useRhUserAtomValue();
  const { isTradeOrContractPage } = useIsTradeOrContractPage();

  const hideIcon = useMemo(() => {
    return (
      isTradeOrContractPage || ["TRADE", "CONTRACT"].includes(userType || "")
    );
  }, [isTradeOrContractPage, userType]);

  if (hideIcon) return null;
  return (
    <svg
      {...props}
      style={style}
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.5 15.8848H14.4231V11.2694C14.4231 10.0798 13.4588 9.11553 12.2692 9.11553H3.65385C2.46431 9.11553 1.5 10.0798 1.5 11.2694V15.8848Z"
        stroke="currentColor"
        stroke-width="0.5"
      />
      <path
        d="M11.0959 3.88462C11.0959 5.61582 9.69247 7.01923 7.96127 7.01923C6.23007 7.01923 4.82666 5.61582 4.82666 3.88462C4.82666 2.15341 6.23007 0.75 7.96127 0.75C9.69247 0.75 11.0959 2.15341 11.0959 3.88462Z"
        stroke="currentColor"
        stroke-width="0.5"
      />
    </svg>
  );
};

export default RHRAccountIcon;
